import { CSSProperties } from 'react';
import { Obj } from '@/types/common';

export function getColor(
  color: string | Obj | null | undefined,
  defaultColor: CSSProperties['color'] = 'transparent'
): string {
  if (!color) return defaultColor;
  if (typeof color === 'string') return color;
  // TODO use .light while there is no other theme
  return typeof color === 'object' && 'light' in color && 'dark' in color
    ? color.light
    : defaultColor;
}
